<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    

      
      
    </base-header>


    <div class="container-fluid mt--6">
      <div class="row">
     	 <div class="col">
     	 
     <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">Invoices Due</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="invoices_due">
            <el-table-column label="Invoice ID"
                             prop="id"
                             min-width="140px"
                             >
            </el-table-column>
		     <el-table-column label="Title"
                             prop="title"
                             min-width="220px"
                             >
            </el-table-column>
            
            <el-table-column label="Amount"
                             prop="amount_str"
                             min-width="140px"
                             >
            </el-table-column>
            
             <el-table-column label="Due"
                             prop="deadline_str"
                             min-width="140px"
                             sortable>
            </el-table-column>
            
             <el-table-column label="" >
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewInvoice(scope.row)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
        	
        	
          
        </el-table>
    </div>
    <!-- end invoices due -->
    <div style="min-height:120px;"></div>
    
    
    
    
    <div class="card bg-default shadow">
        <div class="border-0 card-header bg-transparent">
            <h3 class="mb-0 text-white">Invoices Paid</h3>
        </div>

        <el-table class="table-responsive table-dark"
                  header-row-class-name="thead-dark"
                  :data="invoices_paid">
            <el-table-column label="Invoice ID"
                             prop="id"
                             min-width="100px"
                             >
            </el-table-column>
		     <el-table-column label="Title"
                             prop="title"
                             min-width="140px"
                             >
            </el-table-column>
            
            <el-table-column label="Amount"
                             prop="amount_str"
                             min-width="100px"
                             >
            </el-table-column>
            
              <el-table-column label="" >
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewInvoice(scope.row)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
            
      
          
        </el-table>
    </div>
    <!-- end invoices due -->
    
		</div><!-- end col-->
       
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  	  [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      TabPane,
      Tabs,
    },
    data() {
      return {
     	 invoices_due:[],
     	 invoices_paid:[],
	
      };
    },
    methods: {
      viewInvoice(row) {
			this.$router.push( '/view-invoice/'+	row.id);
      }
    },
    mounted() {
      	swal.showLoading();
		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_invoices/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.invoices_due = response.data.invoices_due;
      		 this.invoices_paid = response.data.invoices_paid;
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














